export const API_GET_BIOCHAR_PRODUCTION = 'api/tigercat-burns/dashboard/get-biochar-production';
export const API_GET_FEEDSTOCK_DELIVERED = 'api/tigercat-burns/dashboard/get-feedstock-delivered';

